
export function shuffle<T>(array: Array<T>): Array<T> {
  let tmp = null;
  for (let i = array.length; i > 0; i--) {
    let randomIdx = Math.floor(Math.random() * i);
    tmp = array[randomIdx]
    array[randomIdx] = array[i - 1];
    array[i - 1] = tmp;
  }
  return array;
}



// WEBPACK FOOTER //
// ./src/lib/shuffle.ts